// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + {"545": "vendors","915": "settings-vendors",}[chunkId] + "-" + {"545": "afae7dfe23aeee41","915": "1f9a92758fbd6a24",}[chunkId] + ".js"
}